import React, { useState, useEffect, use } from 'react';

const API_KEY = 'your-bigdatacloud-api-key'; // Get your API key from bigdatacloud.net

const LocationForm = ({ onLocationUpdate, initialLocation ,getLocation}) => {
  const [location, setLocation] = useState(initialLocation || {
    address: '',
    city: '',
    postalCode: '',
    country: '',
    countryCode: '',
    coordinates: null
  });
  const [isLocating, setIsLocating] = useState(false);
  const [error, setError] = useState(null);

  // Function to get coordinates from postal code
  const updateCoordinatesFromPostalCode = async (postalCode) => {
    if (!postalCode || postalCode.length !== 5) return;

    try {
      setIsLocating(true);
      const response = await fetch(
        `https://api.bigdatacloud.net/data/geocode-client` +
        `?postalCode=${postalCode}` +
        `&countryCode=FR` +
        `&localityLanguage=fr`
      );

      if (!response.ok) throw new Error('Erreur lors de la recherche des coordonnées');

      const data = await response.json();
      if (data && data.latitude && data.longitude) {
        const newLocation = {
          ...location,
          city: data.locality || location.city,
          coordinates: {
            latitude: data.latitude,
            longitude: data.longitude
          }
        };
        setLocation(newLocation);
        onLocationUpdate(newLocation);
      }
    } catch (error) {
      setError("Impossible de trouver les coordonnées pour ce code postal");
    } finally {
      setIsLocating(false);
    }
  };


  const getCurrentLocation = () => {
    setIsLocating(true);
    setError(null);

    if (!navigator.geolocation) {
      setError("La géolocalisation n'est pas supportée par votre navigateur");
      setIsLocating(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const response = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=fr`
          );
          
          const data = await response.json();
          
          const newLocation = {
            address: data.locality || '',
            city: data.city || '',
            postalCode: data.postcode || '',
            country: data.countryName || '',
            countryCode: data.countryCode ||'',
            coordinates: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
          };

          setLocation(newLocation);
          onLocationUpdate(newLocation);
        } catch (error) {
          setError("Erreur lors de la récupération de l'adresse");
        }
        setIsLocating(false);
      },
      (error) => {
        setError("Erreur de géolocalisation : " + error.message);
        setIsLocating(false);
      }
    );
  };
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <button
          type="button"
          onClick={getCurrentLocation}
          className="flex items-center px-4 py-2 bg-[#87A96B] text-white rounded-lg hover:bg-[#87A96B]/90 transition-colors disabled:bg-gray-400 font-medium shadow-md"
          disabled={isLocating}
        >
          {isLocating ? (
            <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
          ) : (
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          )}
          {isLocating ? 'Localisation en Cours...' : 'Me localiser'}
        </button>
      </div>

      {error && (
        <div className="bg-red-100 text-red-700 p-3 rounded-lg mb-4 border border-red-200">
          {error}
        </div>
      )}

      <div className="grid grid-cols-1 gap-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="block text-[#2C3E50] font-medium mb-2">
              Ville : <span className="text-gray-600">{location.city||'Inconnu'}</span>
          </div>

          <div className="block text-[#2C3E50] font-medium mb-2">
              Code postal : <span className="text-gray-600">{location.postalCode||'Inconnu'}</span>
          </div>
        </div>

        <div className="block text-[#2C3E50] font-medium mb-2">
            Pays : <span className="text-gray-600">{location.country||'Inconnu'}</span>
        </div>
      </div>
    </div>
  );
};

export default LocationForm;